import React, { Component } from "react";
import { SlideInDownAnimation } from "./Animation";

const styles = {
  containerStyle: {
    position: "relative",
    margin: "0 8px",
    fontSize: "1em",
    fontWeight: "300",
    lineHeight: "2.8em",
    cursor: "pointer",
    display: "inline-block"
  },
  hintTextStyle: {
    color: "#aeaeae"
  },
  valueStyle: {
    color: "#ed135d"
  },
  bottomLineStyle: {
    display: "block",
    width: "100%",
    height: "1px",
    position: "absolute",
    bottom: "0.42em",
    background: "#aeaeae"
  }
};

class TextButton extends Component {
  static defaultProps = {
    placeholder: "[Select]",
    value: "",
    onChange: () => {}
  };

  renderText = () => {
    const { value, placeholder } = this.props;
    if (value === "") {
      return <span style={styles.hintTextStyle}>{placeholder}</span>;
    } else {
      return <span style={styles.valueStyle}>{value}</span>;
    }
  };
  render() {
    const Animation = this.props.reload ? SlideInDownAnimation : "span";
    return (
      <Animation>
        <span style={styles.containerStyle} onClick={this.props.onClick}>
          {this.renderText()}
          <span style={styles.bottomLineStyle} />
        </span>
      </Animation>
    );
  }
}

export { TextButton };



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Shared/TextButton.js